import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { technologies: Array };
  static targets = ['technologyCheckbox', 'attributeRow', 'attributeSection', 'noTechMessage'];

  connect() {
    this._selectedTechIds = [];
    var self = this;

    (this.technologiesValue || []).forEach(function(tech) {
      if (tech.selected) {
        self._selectedTechIds.push(tech.id);
      }
    });

    this._updateVisibility();
  }

  onTechChange(event) {
    var id = parseInt(event.target.value, 10);
    if (event.target.checked) {
      if (this._selectedTechIds.indexOf(id) === -1) {
        this._selectedTechIds.push(id);
      }
    } else {
      this._selectedTechIds = this._selectedTechIds.filter(function(tid) { return tid !== id; });
    }
    this._updateVisibility();
  }

  _updateVisibility() {
    var selected = this._selectedTechIds;
    var hasAny = selected.length > 0;

    this.attributeRowTargets.forEach(function(row) {
      var techIds = JSON.parse(row.dataset.technologyIds || '[]');
      var visible = techIds.some(function(id) { return selected.indexOf(id) !== -1; });
      row.style.display = visible ? '' : 'none';
    });

    if (this.hasNoTechMessageTarget) {
      this.noTechMessageTarget.style.display = hasAny ? 'none' : '';
    }

    if (this.hasAttributeSectionTarget) {
      this.attributeSectionTarget.style.display = hasAny ? '' : 'none';
    }
  }
}
